/* eslint-disable no-use-before-define */
/* eslint-disable linebreak-style */
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */

import React, { useEffect } from 'react';
import { ComponentBootstrap } from '@demant/react-bootstrap';
import flexSpotSchema from '@demant/react-bootstrap/lib/schemas/flex-spot-json';
var CustomBannerReactComponent = function CustomBannerReactComponent(_ref) {
  var settings = _ref.settings,
    component = _ref.component;
  var element = settings.elements[0];
  var componentData = {
    imageLeft: element['image-left'] ? element['image-left'].image.src : null,
    imageRight: element['image-right'] ? element['image-right'].image.src : null,
    backgroundImage: element['background-image'] ? element['background-image'].image.src : null,
    contentHtml: element['banner-content'] ? element['banner-content'].html.html : null,
    link: element.link ? element.link.link : null,
    customDelay: element['custom-delay'] ? element['custom-delay'].html.html : null
  };
  useEffect(function () {
    if (settings && sessionStorage.getItem('popUpClose') === null) {
      displayHandler();
      moveBannerUnderNavigation();
      var customDelay = componentData.customDelay && componentData.customDelay.indexOf('delay') > -1 ? findCustomDelay(componentData.customDelay) : 2000;
      setTimeout(function () {
        setTimeout(function () {
          return component.classList.add('active-banner');
        }, 200);
        component.style.display = 'flex';
      }, customDelay);
    }
  }, []);
  var findCustomDelay = function findCustomDelay(delayString) {
    var delayIndex = delayString.indexOf('delay');
    var digit = "".concat(delayString.slice(delayIndex, delayIndex + 10).replace(/\D+/g, ''), "000");
    return parseFloat(digit);
  };
  var closeHandler = function closeHandler() {
    sessionStorage.setItem('popUpClose', 'true');
    component.classList.remove('active-banner');
    setTimeout(function () {
      component.style.display = 'none';
    }, 100);
  };
  var hideContent = function hideContent() {
    var popupBanner = document.querySelector('.flex-banner');
    var topMenu = document.querySelector('.navigation .menu-lv1');
    var bottomMenu = document.querySelector('.navigation .menu-lv2');
    popupBanner.classList.add('hide-content');
    popupBanner.classList.remove('show-content');
    moveBannerUnderNavigation();

    // move banner on navigation hover
    bottomMenu.addEventListener('mouseenter', function () {
      if (topMenu.classList.contains('navIsOpen')) {
        moveBannerUnderNavigation();
      }
    });
  };
  var showContent = function showContent() {
    setTimeout(function () {
      var popupBanner = document.querySelector('.flex-banner');
      popupBanner.classList.add('show-content');
      popupBanner.classList.remove('hide-content');
      moveBannerUnderNavigation();
    }, 0);
  };
  var moveBannerUnderNavigation = function moveBannerUnderNavigation() {
    setTimeout(function () {
      var popupBanner = document.querySelector('.popup-banner__top .flex-banner');
      if (popupBanner && window.innerWidth >= 768) {
        var navHeight = document.querySelector('.navigation') ? document.querySelector('.navigation').getBoundingClientRect().height : 0;
        var subNavHeight = document.querySelector('.navigation .menu-lv2 ul.open') ? document.querySelector('.navigation .menu-lv2 ul.open').getBoundingClientRect().height : 0;
        var bannerTopPosition = navHeight + subNavHeight;
        popupBanner.style.top = bannerTopPosition + "px";
      }
    }, 400);
  };
  function displayHandler() {
    var topMenu = document.querySelector('.navigation .menu-lv1');
    window.addEventListener('scroll', function () {
      if (component.classList.contains('popup-banner__side')) {
        return null;
      }
      if (topMenu.classList.contains('navIsOpen')) {
        showContent();
      } else {
        hideContent();
      }
      return null;
    });
  }
  function showContentOnClick() {
    var popupBanner = document.querySelector('.flex-banner');
    if (window.innerWidth >= 768 && component.classList.contains('popup-banner__side')) {
      return null;
    }
    if (popupBanner.classList.contains('show-content')) {
      popupBanner.classList.remove('show-content');
      popupBanner.classList.add('hide-content');
    } else {
      popupBanner.classList.add('show-content');
      popupBanner.classList.remove('hide-content');
    }
    return null;
  }
  var handleKeyDown = function handleKeyDown(e) {
    var closeButton = document.querySelector('.flex-banner__close');
    var popupBanner = document.querySelector('.flex-banner');
    if (e.key === 'Escape' || e.key === 'Enter' && closeButton === document.activeElement) {
      closeHandler();
    }
    if (e.key === 'Enter' && popupBanner === document.activeElement) {
      showContentOnClick();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, componentData.contentHtml && /*#__PURE__*/React.createElement("div", {
    className: componentData.imageRight ? 'flex-banner reverse' : 'flex-banner',
    style: {
      backgroundImage: componentData.backgroundImageSrc ? componentData.backgroundImageSrc : ''
    },
    onClick: showContentOnClick,
    onKeyDown: handleKeyDown,
    tabIndex: "0",
    role: "link"
  }, (componentData.imageRight || componentData.imageLeft || componentData.imageDevice) && /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__image",
    style: {
      backgroundImage: "url('".concat(componentData.imageLeft ? componentData.imageLeft : componentData.imageRight, "')")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__content__text",
    dangerouslySetInnerHTML: {
      __html: componentData.contentHtml
    }
  }), componentData.link && /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__content__button",
    role: "button"
  }, /*#__PURE__*/React.createElement("a", {
    href: componentData.link.href,
    className: "button popup-button"
  }, componentData.link.content))), /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__close lightbox-close",
    onClick: closeHandler,
    onKeyDown: handleKeyDown,
    role: "button",
    tabIndex: "0"
  }, "\uEAE3")));
};
var c = new ComponentBootstrap('.flex-spot.popup-banner ');
c.schemaData = flexSpotSchema;
c.reactApp = CustomBannerReactComponent;
setTimeout(function () {
  return c.run();
}, 0);